{
  "instagram_url": "https://www.instagram.com/grileinfo/",
  "instagram_name": "grileinfo",
  "facebook_url": "https://www.facebook.com/profile.php?id=61551697088326",
  "facebook_name": "Grile.info",
  "community_url": "",
  "grile_count": 30000,
  "pages_enabled": true,
  "particles_enabled": false,
  "light_mode_enabled": false,
  "guided_tour_enabled": false,
  "community_toast_enabled": false,
  "multiple_faculties_enabled": false,
  "ranking_enabled": false,
  "subject_cohort_enabled": false,
  "objective": "specializare",
  "objective_articulated": "specializarea",
  "objective_plural": "specializări",
  "objective_plural_articulated": "specializările",
  "exam_type": "rezidențiat",
  "exam_type_articulated": "rezidențiatul",
  "exam_type_plural": "examene de rezidențiat",
  "exam_type_plural_articulated": "examenele de rezidențiat",
  "order_materii": ["kumar", "lawrence", "sinopsis", "sinopsis de medicina"],
  "materie": "carte",
  "materii": "cărți"
}
